import React from 'react';
import UserContext, {User} from './UserContext';
import {decodeJwt} from 'jose';

function getSecondsRemainingInSession(token?: string): number {
  if (!token) {
    return 0;
  }

  const payload = decodeJwt(token) as Record<string, string> | undefined;
  if (!payload) {
    return 0;
  }
    
  const exp = Number(payload.exp);
  if (isNaN(exp)) {
    return 0;
  }

  const now = Math.floor(Date.now() / 1000);
  return exp - now;
}

const UserProvider: React.FC = ({children}) => {
  const [user, setUser] = React.useState<User|undefined>(undefined);
  const [apiToken, setApiToken] = React.useState<string|undefined>(undefined);

  function signIn(user: User, token: string): void {
    // save user info into memory
    setUser(user);

    // save user in session storage so page reloads
    // can get the user info
    const serialized = JSON.stringify(user);
    sessionStorage.setItem('digiknow-user', serialized);

    setApiToken(token || 'missing-token');
    sessionStorage.setItem('digiknow-api', token || 'missing-token');
  }

  function signOut(): void {
    setUser(undefined);
    setApiToken(undefined);
    sessionStorage.removeItem('digiknow-user');
    sessionStorage.removeItem('digiknow-api');
  }

  const savedUser = sessionStorage.getItem('digiknow-user');
  const savedToken = sessionStorage.getItem('digiknow-api');
  if (!user && savedUser && savedToken) {
    const user = JSON.parse(savedUser) as User;
    signIn(user, savedToken);
  }

  const timeRemaining = getSecondsRemainingInSession(apiToken || '');

  return (
    <UserContext.Provider value={{signIn, signOut, secondsRemainingInSession: timeRemaining, user, apiToken}}>
      {children}
    </UserContext.Provider>
  );
}
export default UserProvider;
